import Axios from "axios";
import { useQuery } from "react-query";
import { baseDataKeys } from "src/query-keys";

export function useSrids() {
  async function queryFn(): Promise<number[]> {
    const result = await Axios.get("/planning-api/srids");
    return result.data;
  }
  return useQuery(baseDataKeys.srids, queryFn);
}
